import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {getAllOrders} from "../../../redux/actions/orders";

const FilterOrdersComponent = (props) => {
    console.log(props);
    const {search, page, perPage} = props;
    const dispatch = useDispatch();
    const [query, setQuery] = useState(search);
    useEffect(() => {
        let time = setTimeout(() => {
            dispatch(getAllOrders({
                page : page,
                perPage: perPage,
                query : query
            }));
        },1000);
        return () => clearTimeout(time);
    },[dispatch, query]);
    return (
        <>
            <div className="bg-white shadow-sm rounded filter-orders-holder">
                <div className="form-group row">
                    <label htmlFor="username" className="col-lg-2 col-form-label text-md-right">جستجو با نام و موبایل مشتری یا کد سفارش :</label>
                    <div className="col-lg-3">
                        <input id="username" type="text"
                               className="form-control"
                               name="search"
                               autoFocus={true}
                               value={query}
                               onChange={(search) => {
                                   search = search.target.value;
                                   setQuery(search);
                               }}
                               autoComplete="search"
                        />
                    </div>
                </div>
            </div>
        </>
    )
};

export default FilterOrdersComponent;
